import { render, staticRenderFns } from "./EntryHome.vue?vue&type=template&id=2bdb0773&scoped=true&"
import script from "./EntryHome.vue?vue&type=script&lang=js&"
export * from "./EntryHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdb0773",
  null
  
)

export default component.exports